var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"places-form-notes"},[(_vm.place)?[_c('visit-list',{attrs:{"filter":{ place: _vm.place.id },"place":_vm.place}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }